const config = window.APP_CONFIG;

const emailTemplatesNL = [
  // 0. CEO Fraud (leeg)
  {
    id: 0,
    language: "nl",
    subject: "Snelle reactie",
    body: `<p>Hallo {{nickname}}</p><p>Ik zit momenteel in een vergadering en heb je nodig om nu een snelle taak voor me uit te voeren. Stuur me je WhatsApp-nummer en wacht op mijn bericht.</p>
    <p class="pt-4">Met vriendelijke groet,</p><p>${config.CEO}</p>`,
    sender: `${config.CEO} <alainhenrard76@gmail.com>`,
    isPhishing: true,
    footer: ``
  },

  // 1. Security Mail – verdachte login
  {
    id: 1,
    language: "nl",
    subject: "Ongebruikelijke aanmeldingsactiviteit gedetecteerd",
    body: `
    <div style="text-align:center;">
      <img src="/images/microsoft.png" alt="Microsoft logo" style="display:block; margin: 0 auto; height: 150px;" />

      <p class="pb-4" style="font-size:15px; line-height:1.6; color:#333;">
        We hebben een poging tot aanmelden op je Microsoft-account opgemerkt vanaf een nieuw apparaat of locatie.
      </p>

      <p style="font-size:15px; line-height:1.6; color:#333;">
        We raden je aan je accountinstellingen onmiddellijk te controleren.
      </p>

      <div style="margin: 24px 0;">
        <a href="https://micr0s0ft.com/login" style="background:#dc3545;color:white;padding:12px 20px;border-radius:4px;text-decoration:none;font-weight:bold;">
          Controleer activiteit
        </a>
      </div>

      <p style="font-size:13px; color:#666;">Activiteit gedetecteerd: 05 juni 2025 om 10:42 (CET)</p>
    </div>
  `,
    sender: "Microsoft Beveiliging <security@micr0s0ft.com>",
    isPhishing: true,
    footer: `
    <div style="font-size:12px; color:#888; padding-top:10px; text-align:center;">
      Deze e-mail is automatisch gegenereerd. Reageer niet rechtstreeks op dit bericht.<br />
      Bezoek je <a href="https://account.microsoft.com/security" style="color:#dc3545; text-decoration:underline;">beveiligingsinstellingen</a> voor meer informatie.
    </div>
  `
  },


  // 2. Interne Events – inschrijven
  {
    id: 2,
    language: "nl",
    subject: "Uitnodiging: Teambuilding op locatie – schrijf je nu in",
    body: `
    <div style="text-align:center;">
      <p style="font-size:15px; line-height:1.6; color:#333;">Hallo {{nickname}},</p>

      <p style="font-size:15px; line-height:1.6; color:#333;">
        De inschrijvingen voor ons volgende teambuilding event zijn geopend.
      </p>

      <p style="font-size:15px; line-height:1.6; color:#333;">
        We kijken ernaar uit om er samen een geslaagde dag van te maken!
      </p>

      <div style="margin: 24px 0;">
        <a href="https://${config.companyDomain}/inschrijven" style="background:#007bff;color:white;padding:12px 20px;border-radius:4px;text-decoration:none;font-weight:bold;">
          Inschrijven
        </a>
      </div>
    </div>
  `,
    sender: `Eventteam <events@${config.companyDomain}>`,
    isPhishing: false,
    footer: `
    <div style="font-size:12px; color:#888; padding-top:10px; text-align:center;">
      Deze uitnodiging werd verstuurd door het interne eventteam.<br />
      Vragen? Contacteer <a href="mailto:events@${config.companyDomain}" style="text-decoration:underline;color:#007bff;">events@${config.companyDomain}</a>
    </div>
  `
  }
  ,

  // 3. Holiday – kerstfeest
  {
    id: 3,
    language: "nl",
    subject: "🎄 Uitnodiging: Kerstfeest op kantoor",
    body: `
    <div style="text-align:center;">
      <img src="/images/christmas.jpg" alt="Kerstfeest" style="display:block; margin: 0 auto;height:150px;margin-bottom:12px;" />
      <p>Beste Collegas</p>
      <p style="font-size:15px;">🎅 Het jaarlijkse kerstfeest komt eraan! Kom jij ook?</p>
      <p style="font-size:15px;">Registreer je hieronder om je aanwezigheid te bevestigen.</p>
      <div style="margin:16px 0;">
        <a href="https://${config.companyDomain}/kerstfeest" style="background:#00aca9;color:white;padding:10px 16px;border-radius:4px;text-decoration:none;">Ik ben erbij</a>
      </div>
      </div>

    `,
    sender: `HR Afdeling <hr@${config.companyDomain}>`,
    isPhishing: false,
    footer: `<div style="font-size:12px;color:#888;text-align:center;">
      Organisatie via HR. Antwoord vóór 15 december.
    </div>`
  },

  // 4. IT – software update
  {
    id: 4,
    language: "nl",
    subject: "Belangrijke beveiligingsupdate vereist – vandaag uitvoeren",
    body: `
    <div style="text-align:center;">
      <p class="pb-4" style="font-size:15px; line-height:1.6; color:#333;">Goedemorgen {{nickname}},</p>

      <p class="pb-4" style="font-size:15px; line-height:1.6; color:#333;">
        Er is een belangrijke beveiligingsupdate beschikbaar voor jouw werkstation. Om risico’s te beperken, vragen we om deze vandaag nog uit te voeren.
      </p>

      <p style="font-size:15px; line-height:1.6; color:#333;">
        Klik op onderstaande knop om de update direct te starten.
      </p>

      <div style="margin: 24px 0;">
        <a href="https://${config.companyDomainPhishing}/update" style="background:#ffc107;color:black;padding:12px 20px;border-radius:4px;text-decoration:none;font-weight:bold;">
          Start update
        </a>
      </div>

      <p style="font-size:13px; color:#666;">
  Update-ID: KB509821 — beschikbaar sinds ${new Date().toLocaleDateString('nl-BE')}
</p>

    </div>
  `,
    sender: `IT Beheer <it@${config.companyDomainPhishing}>`,
    isPhishing: true,
    footer: `
    <div style="font-size:12px; color:#888; padding-top:10px; text-align:center;">
      Heb je vragen? Contacteer <a href="mailto:it@${config.companyDomainPhishing}" style="text-decoration:underline;color:#ffc107;">it@${config.companyDomainPhishing}</a><br />
      Deze melding werd automatisch verstuurd vanuit het IT-beheersysteem.
    </div>
  `
  }
  ,

  // 5. Account Notification – nieuwe melding
  {
    id: 5,
    language: "nl",
    subject: "Er is gereageerd op je bijdrage",
    body: `
      <div style="text-align:center;">

    <img src="/images/linkedin.png" alt="LinkedIn" style="display:block;margin:0 auto;height:200px;" />
    <p style="font-size:15px; line-height:1.6;">Iemand heeft zojuist een reactie geplaatst op een van je recente bijdragen.</p>
    <p style="font-size:15px; line-height:1.6;">Bekijk de reactie en start het gesprek.</p>
    <div style="margin:20px 0;">
      <a href="https://www.Iinkedin/activity/post/8394" style="background:#0077b5;color:white;padding:10px 20px;border-radius:4px;text-decoration:none;display:inline-block;">Bekijk activiteit</a>
    </div>
        </div>

  `,
    sender: "LinkedIn Meldingen <noreply@Iinkedin.com>",
    isPhishing: true,
    footer: `<div style="font-size:12px;color:#888;padding-top:10px;text-align:center;">
    Je ontvangt deze melding op basis van je notificatie-instellingen.<br />
    <a href="https://www.Iinkedin.com/settings/" style="color:#0077b5;text-decoration:underline;">Beheer je instellingen</a>
  </div>`
  },


  {
    id: 6,
    language: "nl",
    subject: "Ontvang €10 korting op je volgende HelloFresh box",
    body: `
    <div style="text-align:center;">
      <img src="/images/HelloFresh.svg" alt="HelloFresh logo" style="display:block; margin: 0 auto 16px; height: 150px;" />

      <p class="pb-4" style="font-size:15px; line-height:1.6; color:#333;">Beste klant,</p>
      <p class="pb-4" style="font-size:15px; line-height:1.6; color:#333;">
        Als trouwe gebruiker willen we je bedanken met een persoonlijke korting van <strong>€10</strong> op je volgende HelloFresh box.
      </p>

      <p style="font-size:15px; line-height:1.6; color:#333;">Gebruik onderstaande knop om je korting te activeren:</p>

      <div style="margin: 20px 0;">
        <a href="https://hellofresh.be/activeren" style="background:#28a745;color:white;padding:12px 20px;border-radius:4px;text-decoration:none;font-weight:bold;">
          Activeer mijn korting
        </a>
      </div>

      <p style="font-size:13px; color:#666;">Kortingscode: <strong>HF-KERST10</strong></p>
    </div>
  `,
    sender: "HelloFresh België <info@hellofresh.be>",
    isPhishing: false,
    footer: `
    <div style="font-size:12px; color:#888; padding-top:10px; text-align:center;">
      Deze promotie is geldig t.e.m. 31 december en enkel beschikbaar voor geselecteerde gebruikers.<br />
      Bekijk de <a href="https://hellofresh.be/voorwaarden" style="color:#28a745; text-decoration:underline;">algemene voorwaarden</a> voor meer info.
    </div>
  `
  },


  // 7. Social Media – Facebook melding
  {
    id: 7,
    language: "nl",
    subject: "Je hebt een nieuwe reactie op je bericht",
    body: `
    <div style="text-align:center;">

      <img src="/images/fb.svg" alt="Facebook logo" style="display:block; margin: 0 auto 16px; height:40px;" />

      <p style="font-size:15px; color:#333; line-height:1.6;">
        Iemand heeft gereageerd op een van je recente berichten op Facebook.
      </p>

      <p style="font-size:15px; color:#333; line-height:1.6;">
        Bekijk de reactie en blijf op de hoogte van het gesprek.
      </p>

      <div style="margin: 20px 0;">
        <a href="https://facebook-alerts.com/meldingen" style="background:#1877f2;color:white;padding:12px 20px;border-radius:4px;text-decoration:none;font-weight:bold;">
          Naar je melding
        </a>
      </div>
    </div>
  `,
    sender: "Facebook Meldingen <no-reply@facebook-alerts.com>",
    isPhishing: true,
    footer: `
    <div style="font-size:12px; color:#888;padding-top:10px; text-align:center;">
      Deze melding werd verstuurd naar jouw accountinstellingen.<br />
      Facebook vraagt je nooit om persoonlijke gegevens via e-mail.<br />
      <a href="https://facebook.com/settings/notifications" style="color:#1877f2;text-decoration:underline;">Notificatie-instellingen beheren</a>
    </div>
  `
  }
  ,

  // 8. Shipment – Bpost levering
  {
    id: 8,
    language: "nl",
    subject: "Je Bpost-levering is gepland voor morgen",
    body: `
    <div style="text-align:center;">

      <img src="/images/bpost.svg" alt="Bpost logo" style="display:block; margin: 0 auto 16px; height: 100px;" />

      <p style="font-size:15px; line-height:1.6; color:#333;">
        Je pakket is onderweg en wordt <strong>morgen geleverd tussen 09:00 en 13:00</strong>.
      </p>

      <p style="font-size:15px; line-height:1.6; color:#333;">
        Je kunt de status van je zending live volgen via onderstaande knop.
      </p>

      <div style="margin: 20px 0;">
        <a href="https://track.bpost.be/pakket" style="background:#dc3545;color:white;padding:12px 20px;border-radius:4px;text-decoration:none;font-weight:bold;">
          Volg mijn pakket
        </a>
      </div>

      <p style="font-size:13px; color:#666;">Trackingsnummer: 1ZA84XF993712736*</p>
    </div>
  `,
    sender: "Bpost Klantenservice <info@bpost.be>",
    isPhishing: false,
    footer: `
    <div style="font-size:12px; color:#888;text-align:center;">
      Je kunt je pakket volgen tot 7 dagen na levering.<br />
      Vragen? Raadpleeg onze <a href="https://bpost.be/hulp" style="color:#dc3545; text-decoration:underline;">klantenservice</a>.
    </div>
  `
  }
  ,

  // 9. Energy – Eneco factuur (QR code)
  {
    id: 9,
    language: "nl",
    subject: "Je Eneco-factuur van deze maand is beschikbaar",
    body: `
    <div style="text-align:center;">

      <img src="/images/Eneco.png" alt="Eneco logo" style="display:block; margin: 0 auto 16px; height: 150px;" />

      <p style="font-size:15px; line-height:1.6; color:#333;">
        Je nieuwe energiefactuur is beschikbaar in je klantenportaal.
      </p>

      <p style="font-size:15px; line-height:1.6; color:#333;">
        Je kunt deze snel en veilig betalen via onderstaande QR-code.
      </p>

      <div style="margin: 24px 0;">
        <img src="https://api.qrserver.com/v1/create-qr-code/?data=https://eneco-facturatie.be&size=150x150" alt="QR-code voor betaling" style="display:block; margin: 0 auto;" />
      </div>

      <p style="font-size:13px; color:#666;">Factuurnummer: ENE-202406-8127</p>
    </div>
  `,
    sender: "Eneco België <facturen@eneco-facturatie.be>",
    isPhishing: true,
    footer: `
    <div style="font-size:12px; color:#888; padding-top:10px; text-align:center;">
      Deze QR-code is geldig tot de vervaldatum zoals vermeld op je factuur.<br />
      Voor meer informatie bezoek <a href="https://www.eneco.be/mijnfacturen" style="color:#e30613;text-decoration:underline;">Mijn Eneco</a>.
    </div>
  `
  }

];

export default emailTemplatesNL;
